import type { CopyShape } from "@tami/core/intl";

import type { DASHBOARD_COLLAB_SCRIPT_COPY_PT_BR } from "../dashboard-collab-script.copy";

export const DASHBOARD_COLLAB_SCRIPT_COPY_EN_US: CopyShape<typeof DASHBOARD_COLLAB_SCRIPT_COPY_PT_BR> = {
  dashCollabIntro: {
    narrative: "The same dashboard, from the manager's side: your whole creator roster on one screen.",
  },
  dashCollabScope: {
    narrative: "Pick who you want to look at. One creator, a few, or the whole roster — the entire screen follows along.",
    callout: "Filter by creator in one click — including your own Collab.",
  },
  dashCollabGreeting: {
    narrative: "Start the day knowing what each creator needs to post, deliver and sort out.",
    callout: "Good morning, Ana! Your roster summary at a glance.",
  },
  dashCollabOverview1: {
    narrative: "Fewer spreadsheets per creator — one place for the whole roster.",
  },
  dashCollabCards: {
    narrative: "Each creator with combined followers and engagement. Click a card and drill down into their socials.",
    callout: "One card per creator — and your Collab gets its own too.",
  },
  dashCollabOverview2: {
    narrative: "Side-by-side comparison, without opening a tab for each creator.",
  },
  dashCollabKpis: {
    narrative: "Revenue, active campaigns, pending deliverables and engagement — added up across the whole roster.",
    callout: "Combined KPIs: what the Collab has in play right now.",
  },
  dashCollabOverview3: {
    narrative: "No more guessing who's delivering and who's stalled.",
  },
  dashCollabPosts: {
    narrative: "Today's queue with the owner of each item — scan the column and know who's got what.",
    callout: "Every post shows which creator owns it, including the Collab's own content.",
  },
  dashCollabAgenda: {
    narrative: "Shoots, calls and meetings across the roster, with the creator for each appointment.",
    callout: "Roster calendar: who's shooting, who's meeting, and when.",
  },
};
